<template>
    <b-row>
        <div class="d-flex mt-3">
            <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
            <h6 class="bold-heading mt6 ms-1">{{ $t('TaxInfo.title') }}</h6>
        </div>
    </b-row>
    <!-- {{ dataObj }} -->
    <b-row class="my-2 ps-3">
        <b-col sm="10" md="10" lg="10">
            <!-- <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('TaxInfo.Taxprofile') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column mb-5">
                    <span class="details-circle-common">Cardiology Sub-store</span>
                </b-col>
            </b-row> -->
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('TaxInfo.vattinno') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field"> {{ dataObj.VATNo }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('TaxInfo.servicetaxregno') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field"> {{ dataObj.ServiceTaxNo }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('TaxInfo.excercisecode') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field"> {{ dataObj.ExciseCode }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('TaxInfo.incometaxpan') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field"> {{ dataObj.IncomeTaxNo }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('TaxInfo.csttinno') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field"> {{ dataObj.CST }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('TaxInfo.gstno') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field"> {{ dataObj.GSTNO }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('TaxInfo.msme') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field"> {{ dataObj.MSME }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('TaxInfo.rtgscode') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field"> {{ dataObj.RTGSCODE }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('TaxInfo.druglicence') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field"> {{ dataObj.DrugLicence }}</p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        dataObj: {
            type: Object,
            default: {}
        }
    },
    setup() {
        return {

        }
    }

})
</script>

<style lang="scss"></style>